(() => {
  const desktopQuery = window.matchMedia('(min-width: 1200px)');
  const detailSelectors = '.product__description, .product__accordion, share-button';

  function arrange(productInfo) {
    const product = productInfo.querySelector(':scope > .page-width > .product');
    const info = product?.querySelector('.product__info-container');
    const gallerySlot = product?.querySelector('.sil-product-gallery-assurance');
    const isGiftCard = productInfo.dataset.productGiftCard === 'true';
    if (!product || !info) return;

    let details = productInfo.querySelector(':scope > .sil-product-details');
    if (desktopQuery.matches) {
      const targets = [...info.children].filter((node) => node.matches?.(detailSelectors));
      const assurance = isGiftCard ? null : info.querySelector(':scope > .sil-product-assurance-group');
      if (!targets.length && !(assurance && gallerySlot)) return;
      if (!details) {
        details = document.createElement('section');
        details.className = 'sil-product-details page-width';
        details.setAttribute('aria-label', 'Product details');
        details.innerHTML = '<div class="sil-product-details__heading"><p>PRODUCT DETAILS</p><h2>Everything worth knowing.</h2></div><div class="sil-product-details__content"></div>';
        productInfo.querySelector(':scope > .page-width').insertAdjacentElement('afterend', details);
      }
      const content = details.querySelector('.sil-product-details__content');
      targets.forEach((node) => {
        if (!node.__silPlaceholder) {
          node.__silPlaceholder = document.createComment('sil-product-detail-position');
          node.parentNode.insertBefore(node.__silPlaceholder, node);
        }
        content.appendChild(node);
      });
      if (assurance && gallerySlot) {
        if (!assurance.__silPlaceholder) {
          assurance.__silPlaceholder = document.createComment('sil-product-assurance-position');
          assurance.parentNode.insertBefore(assurance.__silPlaceholder, assurance);
        }
        gallerySlot.appendChild(assurance);
      }
    } else if (details) {
      const movedDetails = [...details.querySelectorAll(detailSelectors)];
      const movedAssurance = gallerySlot ? [...gallerySlot.querySelectorAll(':scope > .sil-product-assurance-group')] : [];
      [...movedDetails, ...movedAssurance].forEach((node) => {
        if (node.__silPlaceholder?.parentNode) node.__silPlaceholder.parentNode.insertBefore(node, node.__silPlaceholder);
        node.__silPlaceholder?.remove();
        node.__silPlaceholder = null;
      });
      details.remove();
    }
  }

  function arrangeAll() {
    document.querySelectorAll('product-info').forEach(arrange);
    arrangeSizeOptions();
  }

  function arrangeSizeOptions() {
    document.querySelectorAll('fieldset[data-sil-size-option]').forEach((fieldset) => {
      if (fieldset.dataset.silSizeArranged === 'true') return;
      const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
      if (inputs.length < 2) return;
      const tiers = new Map([
        ['Small', []],
        ['Medium', []],
        ['Large', []],
        ['Statement', []],
      ]);
      const areaFor = (label) => {
        const numbers = (label || '').replace(',', '.').match(/\d+(?:\.\d+)?/g);
        if (!numbers || numbers.length < 2) return 0;
        return Number(numbers[0]) * Number(numbers[1]);
      };
      inputs.forEach((input) => {
        const label = [...fieldset.querySelectorAll('label')].find((node) => node.htmlFor === input.id);
        const text = label?.textContent?.trim() || input.value;
        const area = areaFor(text);
        const tier = area <= 36 ? 'Small' : area <= 156.8 ? 'Medium' : area <= 276 ? 'Large' : 'Statement';
        tiers.get(tier).push({ input, label, area });
      });
      fieldset.querySelectorAll(':scope > input, :scope > label').forEach((node) => node.remove());
      tiers.forEach((items, tierName) => {
        if (!items.length) return;
        items.sort((a, b) => a.area - b.area);
        const group = document.createElement('div');
        group.className = 'sil-size-tier';
        const heading = document.createElement('span');
        heading.className = 'sil-size-tier__label';
        heading.textContent = tierName;
        group.appendChild(heading);
        items.forEach(({ input, label }) => {
          const option = document.createElement('span');
          option.className = 'sil-size-tier__option';
          option.append(input, label);
          group.appendChild(option);
        });
        fieldset.appendChild(group);
      });
      fieldset.dataset.silSizeArranged = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrangeAll);
  else arrangeAll();
  desktopQuery.addEventListener?.('change', arrangeAll);
  document.addEventListener('shopify:section:load', arrangeAll);
})();
